import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import ChatBubbleRoundedIcon from '@mui/icons-material/ChatBubbleRounded';

interface MessagesDialogProps {
  open: boolean;
  onClose: () => void;
  onNavigateToCalls: () => void;
}

export const MessagesDialog: React.FC<MessagesDialogProps> = ({ open, onClose, onNavigateToCalls }) => {

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 800, display: 'flex', alignItems: 'center', gap: 1 }}>
        <ChatBubbleRoundedIcon sx={{ color: '#FF3567' }} />
        Messages & Demandes Clients
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ py: 4, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Aucun message pour le moment.
          </Typography>
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              onClose();
              onNavigateToCalls();
            }}
            sx={{ mt: 2, borderRadius: '20px', fontWeight: 700, textTransform: 'none' }}
          >
            Voir le journal d'appels
          </Button>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>Fermer</Button>
      </DialogActions>
    </Dialog>
  );
};
